import { withPlaceholder } from '../../../Placeholders';
import { TextFieldPlaceholder } from '../../../Placeholders/Templates';
import { AutoComplete } from '..';

export default withPlaceholder({
    customPlaceholder: TextFieldPlaceholder
})(AutoComplete);
